import { SottoCategoriaFaq } from '@hm_app/@core/models/info';
import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class FaqSottocategorieService {

    // Observable sources
    private sottocategoria = new BehaviorSubject<SottoCategoriaFaq>(null);

    // Observable streams
    sottocategoriaObservable = this.sottocategoria.asObservable();

    // Service message commands
    passSottoCategoria(sottocategoria: SottoCategoriaFaq) {
        this.sottocategoria.next(sottocategoria);
    }
}
